/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import * as types from "./types";
import axios from "axios";

const actions = {
  [types.FETCH_RECIPES](context, {recipe}) {
    if (!recipe) throw new Error("The recipe_v2 param is required");

    const modelName = recipe.pdm;
    const requestUrl = `${this.state.endPoints.customizer.transferDesign}${modelName}`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(recipe)
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });

  },
  [types.FETCH_PRICE](context, recipe_v2) {
    if (!recipe_v2) throw new Error("The recipe_v2 param is required");

    const requestUrl = `${this.state.endPoints.customizer.getPrice}`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(recipe_v2)
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
};

export default actions;
